import {AvailableLanguages} from '../enums';
export const XTENANTID = 'X-TenantID';
export const XDOMAIN = 'X-Domain';

export const CPE_REGEX  = /^cpe:2\.3:a(:(((\?*|\*?)([a-zA-Z0-9\-\._]|(\\[\\\*\?!"#$$%&'\(\)\+,/:;<=>@\[\]\^`\{\|}~]))+(\?*|\*?))|[\*\-])){3,5}(:(([a-zA-Z]{2,3}(-([a-zA-Z]{2}|[0-9]{3}))?)|[\*\-])){0,1}(:(((\?*|\*?)([a-zA-Z0-9\-\._]|(\\[\\\*\?!"#$$%&'\(\)\+,/:;<=>@\[\]\^`\{\|}~]))+(\?*|\*?))|[\*\-])){0,4}$/;
export const MAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const PHONE_REGEX = /^[- # * +()0-9]+$/;
export const NUMBER_PATTERN = /^[0-9]*$/;
export const LOWER_AND_UPPER_CASE_LETTERS_PATTERN = /^[a-z]+[a-z|0-9|\-|\\_]{2,}$/;

export const LOCALSTORAGE_USER_UI_LANGUAGE_KEY = 'userUILanguage';
export const LOCALSTORAGE_DEFAULT_UI_LANGUAGE_KEY = AvailableLanguages.it;
export const WORK_SPACE_ROOT_FOLDER = 'Root';
export const EN_DATE_FORMAT = 'MMM dd yyyy';
export const EN_DATE_FORMAT_SHORT = 'MMM dd';
export const EN_DATE_FORMAT_CLASIC = 'MM/dd/yyyy';
export const IT_DATE_FORMAT = 'dd MMM yyyy';
export const IT_DATE_FORMAT_SHORT = 'dd MMM';
export const IT_DATE_FORMAT_CLASSIC = 'dd/MM/yyyy';
export const IT_DATE_FORMAT_WITH_TIME = 'dd/MM/yyyy HH:mm'
export const DEFAULT_RESOURCE_DAYS_DATA = 30;
export const ND = 'N/A';
export const DIALOG_MODE_IDENTIFIER = '@DIALOG_MODE@';

// export const USER_INACTIVITY_STORE = 'userInactivityStoreKey'
export const LOG_INTERNAL_ID = [11]

export const MAX_PDF_ZOOM = 1.8;
export const MIN_PDF_ZOOM = 0.2;
export const PDF_ZOOM_STEP = 0.1;

export const TREATMENT_HOLDER_ICON_KEY = 'treatment-holder.svg';
export const AI_ASSESSMENT_ICON_KEY = 'artificial-intelligence.svg';
export const APP_ASSESSMENT_ICON_KEY = 'app-assessment.svg';
export const COVID_ASSESSMENT_ICON_KEY = 'covid-assessment.svg';
export const PROJECT_CARD_ICON_KEY = 'project.svg';
export const GLOBAL_MEASURE_CHECK_ICON_KEY = 'global-measure-check.svg';
export const TREATMENT_RESPONSIBLE_ICON_KEY = 'treatment-responsible.svg';
export const TREATMENT_SUB_RESPONSIBLE_ICON_KEY = 'treatment-sub-responsible.svg';
export const DATA_BREACH_ICON_KEY = 'data-breach.svg';

export const READ_ONLY_INVALID_ACTIONS = ["EDIT_CHAPTER_TREAT", "EDIT_CHAPTER_CHECK_RA_DPIA", "EDIT_CHAPTER_CUSTOM", "EDIT_CHAPTER_LIA"];
